import { Injectable, signal, TemplateRef } from '@angular/core';
export interface Toast {
  message: string;
  classname?: string; 
  delay?: number;
}
@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private readonly _toasts = signal<Toast[]>([]);
  readonly toasts = this._toasts.asReadonly();

  show(message: string, options: { classname?: string; delay?: number } = {}) {
    const toast: Toast = {
      message,
      classname: options.classname || 'bg-primary text-light',
      delay: options.delay || 5000,
    };
    this._toasts.update((toasts) => [...toasts, toast]);
  }

  remove(toast: Toast) {
    this._toasts.update((toasts) => toasts.filter((t) => t !== toast));
  }

  clear() {
    this._toasts.set([]);
  }
}
